import type { CopyCatalog } from "./copyTypes";

export const FR_COPY: CopyCatalog = {
  "common.loading": "Chargement…",
  "common.yes": "Oui",
  "common.no": "Non",
  "common.notProvided": "Non renseigné",
  "common.notRequired": "Non requis",
  "common.requested": "Demandé",
  "nav.back": "Retour",
  "nav.continue": "Continuer",
  "nav.sendRequest": "Envoyer la demande",
  "nav.sending": "Envoi…",
  "alert.completeFields": "Veuillez renseigner les champs indiqués avant de continuer.",
  "fill.filled": "Renseigné",
  "fill.notFound": "Non trouvé",
  "fill.shipmentToo": "Expédition également renseignée : {detail}",
  "fill.palletMany": "palettes",

  "choose.title": "Comment souhaitez-vous demander votre devis ?",
  "choose.manual.title": "Saisie manuelle",
  "choose.manual.description": "Saisissez les données de votre expédition étape par étape via le formulaire guidé.",
  "choose.manual.action": "Saisir les données manuellement",
  "choose.quickfill.title": "Quick Fill",
  "choose.quickfill.description":
    "Collez les données d’expédition ou importez un document, nous remplirons le formulaire pour vous.",
  "choose.quickfill.action": "Démarrer le remplissage rapide",

  "steps.route": "Itinéraire et commande",
  "steps.shipment": "Expédition",
  "steps.services": "Services supplémentaires",
  "steps.contact": "Contact",
  "steps.review": "Vérification",

  "page.route": "Itinéraire et commande",
  "page.routeSection": "Itinéraire",
  "page.shipment": "Détails de l’expédition",
  "page.services": "Services supplémentaires",
  "page.contact": "Coordonnées",
  "page.contactSection": "Vos coordonnées",
  "page.review": "Vérification",
  "page.quickFill": "Quick Fill",
  "page.analyzing": "Analyse de votre document",

  "route.hintPostcode": "Saisissez un code postal ou une ville pour le chargement et le déchargement.",
  "route.hintFullAddress": "Saisissez l’adresse complète de chargement et de déchargement.",
  "route.unsupported": "Cette route n’est pas prise en charge. Utilisez le formulaire pour {loadCountry} et {unloadCountry}.",
  "route.loading": "Chargement",
  "route.unloading": "Déchargement",
  "route.origin": "Origine",
  "route.destination": "Destination",
  "route.country": "Pays",
  "route.selectCountry": "Sélectionner un pays",
  "route.postcode": "Code postal",
  "route.postcodePlaceholder": "ex. 75001",
  "route.city": "Ville",
  "route.cityPlaceholder": "Saisir la ville",
  "route.street": "Nom de rue",
  "route.streetPlaceholder": "Saisir la rue",
  "route.house": "Numéro",
  "route.housePlaceholder": "ex. 12",
  "route.pickupDate": "Date d’enlèvement souhaitée :",
  "route.unloadDate": "Date de déchargement souhaitée :",
  "route.datePlaceholder": "jj/mm/aaaa",
  "date.clear": "Effacer la date",
  "date.closeCalendar": "Fermer le calendrier",
  "date.openCalendar": "Ouvrir le calendrier",
  "route.specificDateHint":
    "Pour les marchandises disponibles à une date précise. Sinon, nous visons l’option la plus rapide.",
  "route.orderDetails": "Détails de la commande",

  "shipment.goods": "Description des marchandises",
  "shipment.goodsPlaceholder": "Que souhaitez-vous transporter ?",
  "shipment.weight": "Poids total",
  "shipment.qty": "Qté",
  "shipment.type": "Type",
  "shipment.dims": "Dimensions / LDM",
  "shipment.stackable": "Gerable",
  "shipment.addRow": "Ajouter une ligne d’expédition",
  "shipment.totalLines": "Nombre total de lignes : {count}",
  "shipment.selectDims": "Sélectionner les dimensions",
  "shipment.dimsNa": "Dimensions non applicables",
  "shipment.sizeModeDims": "L × l × H",
  "shipment.sizeModeLdm": "LDM",
  "shipment.removeRow": "Supprimer la ligne d’expédition {n}",
  "shipment.lineLabel": "{text}, ligne {n}",
  "shipment.quantity": "Quantité",
  "qty.decrease": "Diminuer la quantité",
  "qty.increase": "Augmenter la quantité",
  "shipment.lengthCm": "Longueur (cm)",
  "shipment.widthCm": "Largeur (cm)",
  "shipment.heightCm": "Hauteur (cm)",
  "shipment.dimensions": "Dimensions",
  "shipment.size": "Taille",
  "shipment.ldm": "LDM",

  "pallet.euro": "Euro",
  "pallet.block": "Block",
  "pallet.ibc": "IBC",
  "pallet.cp3": "CP3",
  "pallet.half": "Demi-palette",
  "pallet.size80x60": "80×60",
  "pallet.size120x120": "120×120",
  "pallet.size150x80": "150×80",
  "pallet.custom": "Sur mesure",
  "pallet.unspecified": "LDM",

  "services.aria": "Services supplémentaires",
  "services.pill.adr": "ADR",
  "services.pill.temp": "Température",
  "services.pill.tail": "Hayon",
  "services.pill.ftl": "FTL",
  "services.pill.time": "Créneau horaire",
  "services.pill.ref": "Référence / remarques",
  "services.pill.references": "Références",
  "services.pill.attachments": "Pièces jointes supplémentaires",
  "services.adrClass": "Classe ADR",
  "services.selectClass": "Sélectionner une classe",
  "services.unNumber": "Numéro ONU",
  "services.unPlaceholder": "ex. 1203",
  "services.min": "Min",
  "services.max": "Max",
  "services.tailLoad": "Hayon au chargement",
  "services.tailUnload": "Hayon au déchargement",
  "services.ftlCopy": "Chargement complet demandé.",
  "services.invoiceRef": "Référence de facture",
  "services.reference": "Référence",
  "services.loadingRef": "Référence de chargement",
  "services.unloadingRef": "Référence de déchargement",
  "services.notes": "Remarques",
  "services.notesPlaceholder": "ex. instructions particulières",
  "services.deadline": "Date limite de livraison souhaitée :",
  "services.deliveryHint":
    "Pour les marchandises à livrer à une date précise. Sinon, nous visons l’option la plus rapide.",
  "services.loadingTime": "Heure de chargement",
  "services.unloadingTime": "Heure de déchargement",
  "services.window": "Créneau",
  "services.fixed": "Fixe",
  "services.at": "à",
  "services.from": "de",
  "services.to": "à",
  "services.timeTypeAria": "Type {title}",
  "services.addFiles": "Ajouter des fichiers",
  "services.attachHint":
    "JPEG, PNG, GIF, WebP ou PDF. Jusqu’à {maxFiles} fichiers, {maxFileMb} Mo chacun, {maxTotalMb} Mo au total.",
  "services.adrClass1": "1 Matières explosives",
  "services.adrClass2": "2 Gaz",
  "services.adrClass3": "3 Liquides inflammables",
  "services.adrClass4": "4 Matières solides inflammables",
  "services.adrClass5": "5 Matières comburantes",
  "services.adrClass6": "6 Matières toxiques / infectieuses",
  "services.adrClass7": "7 Matières radioactives",
  "services.adrClass8": "8 Matières corrosives",
  "services.adrClass9": "9 Matières et objets dangereux divers",
  "services.summary.adr": "Marchandises dangereuses (ADR)",
  "services.summary.temp": "Température contrôlée",
  "services.summary.time": "Créneaux horaires",
  "services.summary.refNotes": "Référence et remarques",
  "services.summary.tail": "Hayon",
  "services.summary.ftl": "FTL",
  "services.summary.attachments": "Pièces jointes supplémentaires",
  "services.tail.loadUnload": "Chargement et déchargement",
  "services.tail.loadOnly": "Chargement uniquement",
  "services.tail.unloadOnly": "Déchargement uniquement",
  "services.time.load": "Chargement : {value}",
  "services.time.unload": "Déchargement : {value}",
  "services.time.deadline": "Échéance : {value}",
  "services.time.fixedSuffix": "{time} (fixe)",
  "services.time.windowRange": "{from} à {until}",
  "services.adr.yes": "Oui",
  "services.adr.classUn": "Classe {class}, ONU {un}",
  "services.adr.classOnly": "Classe {class}",
  "services.adr.unOnly": "ONU {un}",
  "services.temp.range": "{min}°C à {max}°C",
  "services.ref.invoice": "Facture : {value}",
  "services.ref.loading": "Chargement : {value}",
  "services.ref.unloading": "Déchargement : {value}",

  "contact.name": "Nom",
  "contact.company": "Société",
  "contact.email": "E-mail",
  "contact.phone": "Téléphone",
  "contact.comment": "Commentaire supplémentaire",
  "contact.privacyBefore":
    "J’accepte le traitement de mes données personnelles conformément à la ",
  "contact.privacyLink": "politique de confidentialité",
  "contact.privacyAfter": " de Neele-Vat.",

  "result.thankYou": "Merci ! Votre demande a bien été reçue.",
  "result.teamWillContact":
    "Notre équipe vous contactera dans les 60 minutes pendant les heures de bureau.",
  "result.teamWillContactEmail":
    "Notre équipe vous contactera dans les 60 minutes pendant les heures de bureau à l’adresse {email}.",
  "result.previewMode": "Mode aperçu — cette demande n’a pas réellement été envoyée.",
  "result.previewFiles": " Remarque : les fichiers ne peuvent pas être envoyés en mode aperçu.",
  "result.yourReference": "Votre référence",
  "result.copy": "Copier",
  "result.copied": "Copié",
  "result.nextTitle": "Prochaines étapes",
  "result.next1": "Demande reçue.",
  "result.next2": "Demande en cours d’examen.",
  "result.next3": "Réponse sous 60 minutes par e-mail.",
  "result.logged":
    "Nous avons enregistré votre demande. Si vous n’avez pas de nouvelles, contactez-nous via les coordonnées ci-dessous.",
  "result.newQuote": "Démarrer un nouveau devis",
  "result.sendFailed": "Nous n’avons pas pu envoyer votre demande",
  "result.preferDirect": "Préférez-vous nous contacter directement ?",
  "result.backToEdit": "Retour à la modification",
  "result.tryAgain": "Réessayer",
  "result.hideDetails": "Masquer les détails",
  "result.viewSent": "Voir ce que nous avons envoyé",
  "result.error.rateLimited":
    "Vous avez effectué trop de demandes en peu de temps. Veuillez patienter un moment et réessayer.",
  "result.error.forbidden":
    "Cette demande a été bloquée. Veuillez réessayer ou nous contacter directement.",
  "result.error.network":
    "Nous n’avons pas pu envoyer votre demande pour le moment. Vérifiez votre connexion et réessayez.",
  "result.error.tooLarge":
    "Cette demande est trop volumineuse. Utilisez des pièces jointes plus petites ou un commentaire plus court.",
  "result.error.unsupportedType": "Utilisez uniquement des fichiers JPEG, PNG, GIF, WebP ou PDF.",
  "result.error.emailUnavailable":
    "Nous n’avons pas pu envoyer votre demande avec les pièces jointes. Veuillez réessayer ou nous contacter directement.",

  "qf.hint":
    "Collez un e-mail ou des données d’expédition, ou joignez une image ou un PDF. Cela remplace les données déjà saisies.",
  "qf.placeholder":
    "ex. 24 palettes euro de 3011 Rotterdam vers 20095 Hambourg, 12 000 kg, enlèvement demain…",
  "qf.ariaPaste": "Données d’expédition à analyser",
  "qf.attach": "Joindre une image ou un PDF",
  "qf.disclaimer":
    "Tout ce que vous collez ou joignez sert uniquement à remplir cette demande. Cela est traité par notre service d’analyse de documents et n’est pas conservé une fois le formulaire rempli.",
  "qf.fillForm": "Remplir le formulaire",
  "qf.working": "Traitement…",
  "qf.analyzing": "Analyse de vos données…",
  "qf.noFields": "Aucun champ n’a pu être reconnu. Ajoutez plus de détails.",
  "qf.rateLimited": "Vous avez fait trop de demandes. Veuillez patienter un moment et réessayer.",
  "qf.blocked": "Cette demande a été bloquée. Contactez-nous si cela est inattendu.",
  "qf.extractUnavailable":
    "L’analyse de documents n’est pas disponible pour le moment. Collez plutôt les données d’expédition.",
  "qf.genericError": "Une erreur s’est produite. Vérifiez votre réseau ou réessayez.",
  "qf.analyzeTitle": "Analyse de votre document...",
  "qf.analyzeSub": "Cela prend généralement quelques secondes",
  "qf.analyzeStep1": "Lecture de la structure du document",
  "qf.analyzeStep2": "Extraction des informations de base",
  "qf.analyzeStep3": "Identification des lignes d’expédition",
  "qf.removeFile": "Supprimer {name}",

  "error.loadCountry": "Sélectionnez un pays de chargement.",
  "error.loadPostal": "Saisissez le code postal de chargement.",
  "error.loadCity": "Saisissez la ville de chargement.",
  "error.loadStreet": "Saisissez le nom de rue de chargement.",
  "error.loadHouseNumber": "Saisissez le numéro de chargement.",
  "error.unloadCountry": "Sélectionnez un pays de déchargement.",
  "error.unloadPostal": "Saisissez le code postal de déchargement.",
  "error.unloadCity": "Saisissez la ville de déchargement.",
  "error.unloadStreet": "Saisissez le nom de rue de déchargement.",
  "error.unloadHouseNumber": "Saisissez le numéro de déchargement.",
  "error.pickupDate": "Choisissez une date d’enlèvement.",
  "error.unloadDate": "Choisissez une date de déchargement.",
  "error.invalidDate": "Veuillez saisir une date valide.",
  "error.totalWeight": "Saisissez le poids total.",
  "error.goods": "Décrivez les marchandises.",
  "error.loadCityOrPostal": "Saisissez le code postal ou la ville de chargement.",
  "error.unloadCityOrPostal": "Saisissez le code postal ou la ville de déchargement.",
  "error.loadPostalInvalid": "Saisissez un code postal de chargement reconnu.",
  "error.loadCityInvalid": "Saisissez une ville de chargement reconnue.",
  "error.unloadPostalInvalid": "Saisissez un code postal de déchargement reconnu.",
  "error.unloadCityInvalid": "Saisissez une ville de déchargement reconnue.",
  "error.pickupPast": "La date d’enlèvement ne peut pas être dans le passé.",
  "error.unloadPast": "La date de déchargement ne peut pas être dans le passé.",
  "error.unloadBeforePickup": "La date de déchargement ne peut pas être antérieure à la date d’enlèvement.",
  "error.weightRange": "Saisissez un poids compris entre 1 et {max} kg.",
  "error.rangePlain": "{min}–{max}.",
  "error.rangeLdm": "{min}–{max} LDM.",
  "error.rangeCm": "{min}–{max} cm.",
  "error.adrUn": "Saisissez le numéro ONU à 4 chiffres.",
  "error.invoiceRef": "Saisissez la référence de facture.",
  "error.loadingRef": "Saisissez la référence de chargement.",
  "error.unloadingRef": "Saisissez la référence de déchargement.",
  "error.tempMin": "Saisissez la température minimale.",
  "error.tempMax": "Saisissez la température maximale.",
  "error.tempOrder": "Le max doit être au moins égal au min.",
  "error.enterNumber": "Saisissez un nombre.",
  "error.deliveryPast": "La date limite de livraison ne peut pas être dans le passé.",
  "error.deliveryBeforePickup": "La date limite de livraison ne peut pas être antérieure à la date d’enlèvement.",
  "error.tailSides": "Sélectionnez chargement, déchargement ou les deux.",
  "error.attachOne": "Joignez au moins un fichier.",
  "error.enterTime": "Saisissez une heure.",
  "error.enterStartTime": "Saisissez une heure de début.",
  "error.enterEndTime": "Saisissez une heure de fin.",
  "error.enterMinutes": "Saisissez les minutes.",
  "error.completeTime": "Saisissez une heure complète.",
  "error.enterEmail": "Saisissez votre adresse e-mail.",
  "error.validEmail": "Saisissez une adresse e-mail valide.",
  "error.validPhone": "Saisissez un numéro de téléphone valide.",
  "error.personalEmail": "Les adresses e-mail personnelles ne sont pas acceptées.",
  "error.enterName": "Saisissez votre nom.",
  "error.enterCompany": "Saisissez votre société.",
  "error.privacy": "Veuillez accepter pour continuer.",
  "error.quickFillEmpty":
    "Collez des données d’expédition ou joignez une image ou un PDF pour remplir le formulaire.",
  "error.maxFiles": "Vous pouvez joindre jusqu’à {max} fichiers.",
  "error.maxFileMb": "Chaque fichier doit faire {max} Mo ou moins.",
  "error.maxTotalMb": "Les pièces jointes doivent faire {max} Mo ou moins au total.",
  "error.filesSkippedType": "Certains fichiers ont été ignorés. Utilisez JPEG, PNG, GIF, WebP ou PDF.",
  "error.emptySkipped": "Les fichiers vides ont été ignorés.",
  "error.fileEmpty": "Le fichier sélectionné est vide.",
  "error.filesEmptyOrType": "Certains fichiers étaient vides ou n’étaient pas un JPEG, PNG, GIF, WebP ou PDF.",
  "error.attachType": "Joignez un JPEG, PNG, GIF, WebP ou PDF.",
  "error.subjectLong": "L’objet est trop long.",
  "error.emailTextLong": "Les données de la demande sont trop longues.",
  "error.shortenSubject": "Raccourcissez cette valeur pour que l’objet de l’e-mail reste dans {max} caractères.",
  "error.shortenBody":
    "Raccourcissez les données d’expédition ou le commentaire pour que l’e-mail reste dans {max} caractères.",

  "announce.choose": "Choisissez comment demander votre devis",
  "announce.quickfill": "Remplissage rapide : coller des données ou importer un document",
  "announce.route": "Étape 1 sur 5 : itinéraire et commande",
  "announce.shipment": "Étape 2 sur 5 : détails de l’expédition",
  "announce.services": "Étape 3 sur 5 : services supplémentaires",
  "announce.contact": "Étape 4 sur 5 : coordonnées",
  "announce.review": "Étape 5 sur 5 : vérifiez votre demande",
  "announce.received": "Demande reçue",
  "announce.sendFailed": "Nous n’avons pas pu envoyer votre demande",
  "announce.sendFailedAttempt": "Nous n’avons pas pu envoyer votre demande (tentative {n})",
  "announce.completeFields": "Veuillez renseigner les champs indiqués avant de continuer.",
  "announce.sending": "Envoi de votre demande…",
};
